export default __webpack_public_path__ + "static/codingGit-7ea8c18d7b3e6e0ded0cc392093f92f9.mp4";